<template>
  <div class="main-video-player-box" :style="{ transform: `scale(${autoScale ? screenScale : 1})` }">
    <div class="video-wrapper" v-if="arena && !isEmpty(arena)">
      <!-- <SRSVideo /> -->
      <TCVideo />
      <button
        v-for="a in arenaList"
        @click="arenaUpdateHandler(a)"
        :key="`arena-${a.id}`"
        class="vjs-custom-arena-button-temp"
        :class="{ active: arena.id === a.id }"
      >
        {{ a.name[streamUrlSelector] || a.name.default }}
      </button>
    </div>
    <div v-else class="no-active-arena">
      <img class="logo" :src="require('@/assets/images/alert.webp')" />
      <div class="text">
        {{ $t('No fight at the moment') }}
      </div>
      <div class="text">
        {{ $t('Please come back again') }}
      </div>
    </div>
    <div :class="['video-banner-wrapper', { 'is-mobile': isMobile }]">
      <div class="odds-wrapper">
        <span>{{ $t('Banker') }}</span>
        <span v-if="autoScale && screenScale > 1" class="ml-16 odds">{{ bankerOdds }}</span>
      </div>
      <div class="odds-wrapper">
        <span v-if="autoScale && screenScale > 1" class="mr-16 odds">{{ playerOdds }}</span>
        <span>{{ $t('Player') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SRSVideo from '@/components/srs-player.vue';
import TCVideo from '@/components/tc-player.vue';
import { FightStatus } from '@/utils/index.model';
import { isMobile } from 'mobile-device-detect';
import { find, isEmpty } from 'lodash';
import 'webrtc-adapter';

export default {
  props: {
    isAnyPopupOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SRSVideo,
    TCVideo,
  },
  data() {
    return {
      screenScale: 1,
      arenaBtns: [],
      // if we have bigPlayButton config here, then auto play is not working
      isMobile,
    };
  },
  computed: {
    ...mapGetters('fight', ['fight']),
    ...mapGetters({
      arena: 'general/selectedArena',
      arenas: 'general/arenas',
      autoScale: 'general/videoAutoScale',
      config: 'general/config',
    }),
    bankerOdds() {
      const banker = find(this.fight.selections, (s) => s.name === 'banker');
      return banker && !isEmpty(banker) ? `${banker.odds}x` : '';
    },
    playerOdds() {
      const player = find(this.fight.selections, (s) => s.name === 'player');
      return player && !isEmpty(player) ? `${player.odds}x` : '';
    },
    isMobileLandscape() {
      return isMobile && this.$screen.width > this.$screen.height;
    },
  },
  methods: {
    isEmpty,
    // listen event
  },
  watch: {
    'fight.status': {
      handler(newVal, oldVal) {
        if (this.isAnyPopupOpen) return;
        if (FightStatus[newVal] === FightStatus.started) {
          if (!isMobile && this.$refs.videoPlayer) {
            this.screenScale = 1 + 285 / (this.$refs.videoPlayer.$el.clientHeight + 50);
          } else if (this.isMobileLandscape && this.$refs.videoPlayer) {
            this.screenScale = this.$screen.height / this.$refs.videoPlayer.$el.clientHeight;
          } else {
            this.screenScale = 1;
          }
        } else {
          this.screenScale = 1;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.main-video-player-box {
  min-height: 200px;
  position: relative;
  z-index: 1002;
  transform-origin: left top;
  transition: all 1s ease;

  &:before {
    content: '';
    background-image: url('~@/assets/images/shine.png');
    height: 30px;
    width: 100%;
    z-index: 2;
    bottom: 0;
    left: 50%;
    display: block;
    position: absolute;
    transform: translateX(-50%);
    background-size: cover;
    pointer-events: none;
  }
  .video-wrapper {
    aspect-ratio: 16/9;

    @supports not (aspect-ratio: 16/9) {
      &::before {
        float: left;
        padding-top: 56.25%;
        content: '';
      }

      &::after {
        display: block;
        content: '';
        clear: both;
      }
    }
  }
  .no-active-arena {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #0d1a24;
    aspect-ratio: 16/9;

    @supports not (aspect-ratio: 16/9) {
      &::before {
        float: left;
        padding-top: 56.25%;
        content: '';
      }

      &::after {
        display: block;
        content: '';
        clear: both;
      }
    }

    img {
      height: 6.4rem;
      width: 6.4rem;
    }

    .text {
      font-size: 16px;
      color: #b2d6ea;
    }
  }

  /*排序顺序*/
  .video-js {
    font-family: 'PingFang SC', 'Helvetica Neue', 'Hiragino Sans GB', 'Segoe UI', 'Microsoft YaHei', '微软雅黑',
      sans-serif;
    width: 100%;

    .vjs-menu-button-inline.vjs-slider-active {
      width: 100px;
    }

    .vjs-menu-button-inline {
      &:focus {
        width: 100px;
      }

      &:hover {
        width: 100px;
      }

      &:before {
        width: 15px;
      }
    }

    .vjs-controls-disabled {
      .vjs-big-play-button {
        display: none !important;
      }
    }

    // .vjs-control {
    //   width: 50px;
    // }

    .vjs-control.vjs-live-control {
      width: auto;
      padding-left: 5px;
      letter-spacing: 1px;
    }

    .vjs-load-progress {
      div {
        display: none !important;
      }
    }

    .vjs-mouse-display {
      &:after {
        padding: 0 0.4em 3px;
        border-radius: 0;
        font-size: 10px;
        padding: 0;
        width: 30px;
        height: 15px;
        line-height: 15px;
        top: -30px;
      }
    }

    .vjs-play-progress {
      &:after {
        padding: 0 0.4em 3px;
        border-radius: 0;
        font-size: 10px;
        padding: 0;
        width: 30px;
        height: 15px;
        line-height: 15px;
        top: -30px;
      }

      background-color: #2483d5;

      &:before {
        top: -3px;
      }
    }

    .vjs-big-play-button {
      top: 50% !important;
      left: 50% !important;
      margin-left: -15px;
      margin-top: -10px;
      background-color: rgba(0, 0, 0, 0.45);
      font-size: 35px;
      height: 20px !important;
      line-height: 20px !important;
      margin-top: -10px !important;

      &:focus {
        background-color: rgba(36, 131, 213, 0.9);
      }

      &:active {
        background-color: rgba(36, 131, 213, 0.9);
      }
    }

    .vjs-loading-spinner {
      border-color: rgba(36, 131, 213, 0.8);
    }

    .vjs-control-bar2 {
      background-color: #000000;
    }

    .vjs-control-bar {
      color: #ffffff;
      font-size: 14px;

      .vjs-play-control {
        order: 0;
      }

      .vjs-playback-rate {
        .vjs-playback-rate-value {
          font-size: 12px;
          line-height: 2.4;
        }

        order: 5;
      }

      .vjs-volume-menu-button {
        order: 3;
      }

      .vjs-resolution-button {
        order: 4;

        .vjs-resolution-button-label {
          display: block;
          line-height: 30px;
        }
      }

      .vjs-fullscreen-control {
        order: 6;
      }
    }

    .vjs-volume-level {
      background-color: #2483d5;
    }

    .vjs-progress-control {
      &:hover {
        .vjs-progress-holder {
          font-size: 1.3px;
        }
      }
    }

    .vjs-menu {
      li {
        padding: 0;
        line-height: 20px;
        font-size: 1.1px;
        font-family: 'PingFang SC', 'Helvetica Neue', 'Hiragino Sans GB', 'Segoe UI', 'Microsoft YaHei', '微软雅黑',
          sans-serif;
      }
    }

    .vjs-time-tooltip {
      border-radius: 0;
      font-size: 10px;
      padding: 0;
      width: 30px;
      height: 15px;
      line-height: 15px;
      top: -30px;
    }

    .vjs-menu-button-popup {
      .vjs-menu {
        width: 50px;
        left: -10px;
      }
    }

    .vjs-menu-button-popup.vjs-volume-menu-button-vertical {
      .vjs-menu {
        left: 0;
      }
    }

    .vjs-progress-control.vjs-control {
      order: 2;
    }
  }

  .video-js.vjs-no-flex {
    .vjs-menu-button-inline {
      width: 100px;
    }
  }

  .vjs-menu-button-inline {
    .vjs-menu {
      left: 30px;
    }
  }

  .vjs-paused.vjs-has-started.vjs-custom-skin {
    > .video-js {
      .vjs-big-play-button {
        display: block;
        display: block;
      }
    }
  }

  .video-js.vjs-ended {
    .vjs-big-play-button {
      display: block;
      display: block !important;
      display: block;
    }

    .vjs-loading-spinner {
      display: none;
    }
  }

  .video-js.vjs-paused {
    .vjs-big-play-button {
      display: block;
      display: block;
    }
  }

  .vjs-seeking {
    .vjs-big-play-button {
      display: none !important;
    }
  }

  .vjs-waiting {
    .vjs-big-play-button {
      display: none !important;
    }
  }

  .video-js {
    &:hover {
      .vjs-big-play-button {
        background-color: rgba(36, 131, 213, 0.9);
      }
    }
  }

  .vjs-menu-button-popup.vjs-volume-menu-button-vertical {
    .vjs-menu {
      left: 0;
    }
  }

  .vjs-button,
  .video-js button {
    cursor: pointer;

    &:before {
      font-size: 20px;
    }
  }

  .vjs-custom-update-button {
    cursor: pointer;
    font-family: 'VJS Material Icons', serif;
    font-weight: normal;
    font-style: normal;

    &:before {
      content: '\e923'; // this relates to a specific icon
      font-size: 20px;
      line-height: 1.67;
    }

    &.disabled:before {
      content: '\e075'; // this relates to a specific icon
      font-size: 20px;
      line-height: 1.67;
    }
  }

  .vjs-custom-resolution-button {
    cursor: pointer;

    .vjs-control-text {
      height: 42px;
      width: 42px;
      display: block;
      clip: unset;
      line-height: 42px;
      position: absolute;
      top: 0;
    }
  }

  .vjs-custom-arena-button-temp {
    cursor: pointer;
    width: 90px !important;
    height: 30px !important;
    padding: 4px 8px !important;
    border-radius: 4px;
    border: solid 1.5px #fff !important;
    background-color: #e4e7eb !important;

    .vjs-control-text {
      clip: unset;
      height: 30px;
      width: 100%;
      display: block;
      color: #1a1d22;
      line-height: 30px;
      top: 0;
      text-transform: uppercase;
      left: 50%;
      transform: translateX(-50%);
    }

    &.active {
      background-color: #08172e !important;

      .vjs-control-text {
        color: #fff;
      }
    }

    &.arena-1 {
      bottom: 50px;
    }

    &.arena-2 {
      bottom: 90px;
    }

    &.arena-3 {
      bottom: 130px;
    }

    &.arena-4 {
      bottom: 170px;
    }

    &.arena-5 {
      bottom: 210px;
    }
  }

  .video-banner-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    height: 48px;
    box-sizing: border-box;
    align-items: center;
    background-image: url('~@/assets/svg/video-banner.svg');
    background-position: center;
    background-size: cover;
    font-size: 12px;
    font-weight: 600;
    line-height: 40px;
    color: #fafafa;
    text-transform: uppercase;

    &.is-mobile {
      display: none;
    }
    .odds-wrapper {
      display: flex;
      align-items: center;

      .odds {
        font-size: 22px;
        color: #fff;
      }
    }
  }
}
</style>
